// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slide-fade-tab-enter-active[data-v-f2023352] {
  transition: all 0.3s ease-out;
}
.slide-fade-tab-leave-active[data-v-f2023352] {
  transition: all 0.1s ease-in;
}
.slide-fade-tab-enter-from[data-v-f2023352] {
  transform: translateY(0px);
}
.slide-fade-tab-leave-to[data-v-f2023352] {
  transform: translateX(100%);
}
.slide-fade-tab-enter-to[data-v-f2023352] {
  transform: translateY(0);
}
.slide-fade-tab-leave-from[data-v-f2023352] {
  transform: translateY(-8px);
  opacity: 1;
}
[data-direction=left] .slide-fade-tab-leave-to[data-v-f2023352] {
  transform: translateX(-100%);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
